<template>
  <div class="">
    <Banner />
    <div class="container">
      <div class="row">
        <Titulo :sombra="false" titulo='Educação é o nosso objetivo!' icon=""
          class="my-4 border-bottom border-3 border-dark-subtle" posicao="center" />

        <div class="col-lg-7 p-4 row">
          <div class="col-sm-6 col-md-4 text-center mb-4">
            <img src="/img/kadu.jpg" alt="" class="img img-fluid rounded-circle">
            <p>
              <small><strong>Kadu Pereyra</strong></small>
            </p>
          </div>
          <div class="col-sm-6 col-md-8 paragrafo">
            <p class="">
              Nosso objetivo é engajar o máximo de pessoas na nova política, uma
              política do bem, que visa o interesse comum e não o interesse
              individual.
            </p>
            <p>
              Nesse novo modelo de política, o eleitor assume seu real papel
              enquanto o político eleito se ajusta a função de servidor público.
            </p>
            <p>
              Totalmente diferente do que acontece na velha política, onde o
              político compra os votos e fica dono do mandato.
            </p>
            <p>
              Nosso caminho será trilhado através da conscientização. Nós
              acreditamos que somente quando a população mudar sua forma de fazer
              política é que teremos políticos diferentes.
            </p>
            <p><br>Afinal, cada povo tem o político que merece.</p>
          </div>
        </div>
        <div class="col-lg-5">
          <Acordeon />
        </div>
      </div>
    </div>
    <Painel id="contadores" class="animate__animated animate__delay container" />
    <div class="col-12 container mt-3" v-if="dados.video_youtube_home">
      <div class="col-md-12 p-3">
        <youtube autoplay="0" :link='dados.video_youtube_home' />
      </div>
    </div>
    <painel-formulario id="formu" class=""></painel-formulario>

    <BlocoParceiros></BlocoParceiros>

    <template v-if="dados.video_podcast_home">
      <div class="col-12 mt-3 bg-dark">
        <div class="container p-3">
          <Titulo :sombra="false" titulo='Podcast Saia do Sofá' icon="" posicao="center" />
          <youtube autoplay="0" :link='dados.video_podcast_home' />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-12 mt-3 bg-dark">
        <div class="container p-3">
          <Titulo :sombra="false" titulo='Podcast Saia do Sofá' icon="" posicao="center" />
          <img src="img/Banner-podcast.png" class="img img-fluid" alt="">
        </div>
      </div>
    </template>

    <div class="container p-0 mt-4">
      <Titulo :sombra="false" titulo='Notícias' icon="" posicao="center" style="padding-bottom: 0px !important;"
        class="border-bottom border-3 border-dark-subtle" />
    </div>
    <painel-noticias id="noticias" class="animate__animated"></painel-noticias>
    <BlocoInstagram id="feed_instagram" class="animate__animated" />
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from "@/components/Banner.vue";
import Painel from "@/components/Painel.vue";
import Acordeon from "@/components/acordeon.vue";
import TituloGrande from "@/components/TituloGrande.vue";
import PainelNoticias from '@/components/PainelNoticias.vue';
import PainelFormulario from '@/components/PainelFormulario.vue';
import { efeito, meta_default } from '@/assets/js/functions'
import Youtube from '@/components/Youtube.vue';
import BlocoInstagram from "@/components/BlocoInstagram.vue";
import Titulo from "@/components/Titulo.vue";
import BlocoParceiros from "@/components/BlocoParceiros.vue";
import { api } from "@/services/api";

export default {
  name: "Home",
  components: {
    Banner,
    Acordeon,
    Painel,
    TituloGrande,
    PainelNoticias,
    PainelFormulario,
    Youtube,
    BlocoInstagram,
    Titulo,
    BlocoParceiros,
  },
  metaInfo: {
    title: 'Educação é o nosso objetivo',
    meta: meta_default("Home")
  },
  data() {
    return {
      telaY: (window.screen.height * 0.75),
      chamaFade: true,
      executaFunc: true,
      dados: {},
    }
  },
  methods: {
    async carrega_dados() {
      this.dados = await api.get('dados_home');
    },
  },
  mounted() {
    this.executaFunc = true
    this.carrega_dados()
    window.onscroll = () => {
      if (this.executaFunc) {
        efeito('numero_consciente', this.telaY, 'zoomIn');
        efeito('numero_multiplicador', this.telaY, 'zoomIn');
        efeito('numero_mais', this.telaY, 'zoomIn');
        efeito('numero_lider', this.telaY, 'zoomIn');
        // efeito('noticias',this.telaY,'bounceInDown');
      }
    }
  },
  unmounted() {
    this.executaFunc = false;
  },
  // watch: {
  //   number(n) {
  //     gsap.to(this.tweened, { duration: 1.5, number: Number(n) || 0 })
  //   }
  // },
};
</script>

<style scoped>
#formu>h2 {
  /* background-color: rgba(5, 6, 30, 0.6); */
  color: var(--cor-base-texto);
  text-shadow: 2px 2px 2px var(--cor-fundo-base);
}
</style>